<template>
  <div class="ine-form__form-wrapper">
    <form @submit.prevent="validateFields" class="impersonate ine-form__form">
      <Title
        header="Impersonate User"
        tagline="Please enter the users email address"
      />
      <Errors :errors="errors.messages" />
      <div
        v-for="(field, key) in fields"
        v-show="field.type"
        :key="`field-${key}`"
        class="ine-form__form-group"
      >
        <input
          v-if="field.type"
          :type="field.type"
          :class="[
            'ine-form__form-control',
            errors.fields.includes(key) && 'ine-form__form-control--error',
          ]"
          @focus="clearErrors"
          :placeholder="field.placeholder"
          :autocomplete="field.autocomplete"
          v-model="field.value"
        />
      </div>
      <div class="ine-form__actions">
        <SubmitBtn title="Submit" iconName="people" :isLoading="isLoading" />
      </div>
      <AdditionalLinks :linksShown="[]" />
    </form>
  </div>
</template>

<script>
import { validateForm, clearFormErrors } from '@/helpers'
import Title from '@/components/forms/elements/Title.vue'
import Errors from '@/components/forms/elements/Errors.vue'
import SubmitBtn from '@/components/forms/elements/SubmitBtn.vue'
import AdditionalLinks from '@/components/forms/elements/AdditionalLinks.vue'

export default {
  name: 'ManageImpersonationForm',
  components: {
    Title,
    Errors,
    SubmitBtn,
    AdditionalLinks,
  },
  data() {
    return {
      errors: clearFormErrors(),
      fields: {
        email: {
          type: 'email',
          placeholder: 'Email',
          rules: ['presence'],
          value: '',
          autocomplete: 'email',
        },
      },
      isLoading: false,
    }
  },
  props: {
    isImpersonating: {
      type: Boolean,
      required: true,
    },
    profile: {
      type: Object,
      required: true,
    },
  },
  methods: {
    validateFields() {
      const { fields } = this
      const { isValid, errors } = validateForm(fields)
      this.errors = errors
      if (isValid) {
        this.submitForm(fields.email.value)
      }
    },
    async submitForm(email) {
      this.isLoading = true
      await this.$store.dispatch('admin/impersonateUser', email)
      this.isLoading = false
      if (this.isImpersonating) {
        this.$router.push({ name: 'home' })
      }
    },
    clearErrors() {
      this.errors = clearFormErrors()
    },
  },
  created() {
    if (this.isImpersonating) {
      this.$store.dispatch(
        'app/setError',
        'Please cancel current impersonation before attempting a new one.'
      )
      this.$router.push({ name: 'home' })
    }
  },
}
</script>
